module.exports = __webpack_public_path__ + "../resources/images/coffee-01-426cc285cb8ee8ea5f1a87536c96d649.jpg";